import { message } from 'antd'

export const handleApiError = (error, { suppress404 = false } = {}) => {
  if (error.status === 404 && suppress404) {
    return
  }

  if (error.status === 401 || error.status === 403) {
    message.destroy()
    if (error.status === 401) {
      message.error('アクセスが拒否されました。')
    } else if (error.status === 403) {
      message.error('アクセスが拒否されました。ネットワーク環境をご確認ください。')
    }
    return
  }

  if (error.json && error.json.message) {
    message.error(error.json.message)
  } else {
    console.error(error)
    message.destroy()
    message.error('予期せぬエラーが発生しました。時間を空けてもう一度お試しください。')
  }
}
